'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var $ = _interopDefault(require('jquery'));
var Analytics = _interopDefault(require('../global/analytics.js'));
var utils_js = require('../helpers/utils.js');
var FormsAPI = _interopDefault(require('./forms-api.js'));
var AjaxForm = _interopDefault(require('./ajax-form.js'));

var AjaxEmailForm = function (_AjaxForm) {
  _inherits(AjaxEmailForm, _AjaxForm);

  function AjaxEmailForm(form, options) {
    _classCallCheck(this, AjaxEmailForm);

    var $form = utils_js.isJquery(form) ? form : $(form);
    var validations = $form.find('input[type="email"]').get().map(function (el) {
      return {
        name: $(el).attr('name'),
        fn: FormsAPI.validateEmail
      };
    });

    return _possibleConstructorReturn(this, (AjaxEmailForm.__proto__ || _Object$getPrototypeOf(AjaxEmailForm)).call(this, form, validations, options));
  }

  _createClass(AjaxEmailForm, [{
    key: 'trackSuccess',
    value: function trackSuccess() {
      var successEvent = this.$form.data('gaFormSuccessEvent');

      if (successEvent) {
        Analytics.track(successEvent, 'Email form', 'Success');
      }
    }
  }]);

  return AjaxEmailForm;
}(AjaxForm);

module.exports = AjaxEmailForm;
